import { FetchDataStoresApi } from 'shared/types';
import { ReactComponent as GlueMetaStoreIcon } from '@elementary/common-ui/assets/16x16/glue-metastore.svg';
import multipleDestinationsRenderer from '../../shared/multipleDestinationsRenderer';

const ICONS_MAP = {
  GLUE: <GlueMetaStoreIcon />,
};

const multipleDataCatalogRenderer = ({
  integrations,
  onChange,
}: {
  integrations?: FetchDataStoresApi['integrations'];
  onChange: (id: string) => void;
}) =>
  multipleDestinationsRenderer({
    integrations:
      integrations?.map((dataStore) => ({
        id: dataStore.id,
        icon: ICONS_MAP[dataStore.config.catalog_type] || null,
        name: dataStore.name,
        status: 'connected',
      })) || [],
    onChange: (_, id) => onChange(id),
    options: [{ value: 'update', label: 'Edit connection' }],
  });
export default multipleDataCatalogRenderer;
